import { render, staticRenderFns } from "./ViewBucketModal.vue?vue&type=template&id=50024405&"
import script from "./ViewBucketModal.vue?vue&type=script&lang=js&"
export * from "./ViewBucketModal.vue?vue&type=script&lang=js&"
import style0 from "./ViewBucketModal.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports